import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76991150"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pannel bg-white"
}
const _hoisted_2 = { class: "flex p-3 justify-content-between header align-items-center" }
const _hoisted_3 = { class: "flex gap-3 align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "ci-action-check text-primary-blue"
}
const _hoisted_5 = {
  key: 1,
  class: "ci-action-close text-red"
}
const _hoisted_6 = {
  key: 2,
  class: "app-label-small font-bold text-default-gray"
}
const _hoisted_7 = {
  key: 3,
  class: "app-label-small font-bold text-default-gray"
}
const _hoisted_8 = {
  key: 4,
  class: "app-label-small font-bold text-default-gray"
}
const _hoisted_9 = {
  key: 0,
  class: "app-label-micro text-primary-blue"
}
const _hoisted_10 = {
  key: 1,
  class: "app-label-micro text-red"
}
const _hoisted_11 = { class: "flex flex-column align-items-start gap-3 p-6" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-column gap-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-d1 font-bold" }, "Partage activé avec succès", -1))
const _hoisted_14 = {
  key: 0,
  class: "app-label text-default-gray"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Le partage du jumeau numérique ")
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = {
  key: 1,
  class: "app-label text-default-gray"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Le partage de l'entité ")
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" a bien été activé. Vous pouvez dès à présent y accéder. ")
const _hoisted_22 = {
  key: 1,
  class: "flex flex-column gap-3"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-d1 font-bold" }, "Une erreur est survenue", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "app-label text-default-gray" }, "Le partage n'a pas pu être activé.", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.authorization.entity_id)
                ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                : (_openBlock(), _createElementBlock("i", _hoisted_5)),
              (_ctx.authorization.building)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Partage de jumeau numérique"))
                : (_ctx.authorization.group_entity)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Partage d'entité"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, "Validation de partage"))
            ]),
            (_ctx.authorization.entity_id)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Validé"))
              : (_openBlock(), _createElementBlock("p", _hoisted_10, "Erreur"))
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.authorization.entity_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  (_ctx.authorization.building)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("span", _hoisted_16, "\"" + _toDisplayString(_ctx.authorization.building.label) + "\"", 1),
                        _createTextVNode(" situé au " + _toDisplayString(_ctx.authorization.building.address.formatted_address) + " a bien été activé. Vous pouvez dès à présent y accéder. ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.authorization.group_entity)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("span", _hoisted_19, "\"" + _toDisplayString(_ctx.entityType) + " - " + _toDisplayString(_ctx.authorization.group_entity.name) + "\"", 1),
                        (_ctx.authorization.group_entity.address)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "situé au " + _toDisplayString(_ctx.authorization.group_entity.address.formatted_address), 1))
                          : _createCommentVNode("", true),
                        _hoisted_21
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25)),
            _createVNode(_component_router_link, { to: "/login" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_button, {
                  buttonType: "main",
                  buttonSize: "m",
                  buttonText: "Suivant"
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 1,
          mode: "indeterminate",
          class: "h-5rem"
        }))
      : _createCommentVNode("", true)
  ], 64))
}